(function () {
  var lastTrigger = null;

  function setFocusBack() {
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
      return;
    }
    if (document.body && typeof document.body.focus === 'function') {
      document.body.focus();
    }
  }

  function openModalById(id, triggerEl) {
    if (!id) return;

    var modal = document.getElementById(id);
    if (!modal) return;

    lastTrigger = triggerEl || null;

    // Lazy-load iframe when using data-src (Step 2)
    var iframe = modal.querySelector('.tix-modal__iframe');
    if (iframe && iframe.dataset && iframe.dataset.src) {
      var currentSrc = iframe.getAttribute('src') || '';
      if (currentSrc !== iframe.dataset.src) {
        iframe.setAttribute('src', iframe.dataset.src);
      }
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tix-modal-open');

    // Focus close button first, then container. Do not focus overlay.
    var closeBtn = modal.querySelector('.tix-modal__close, [data-tix-close], button[data-micromodal-close]');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      closeBtn.focus();
      return;
    }

    var container = modal.querySelector('.tix-modal__container');
    if (container && typeof container.focus === 'function') {
      container.focus();
    }
  }

  function closeModal(modal) {
    if (!modal) return;

    if (modal.contains(document.activeElement)) {
      setFocusBack();
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tix-modal-open');

    setFocusBack();
  }

  document.addEventListener('click', function (e) {
    // Open triggers (support both attributes)
    var trigger =
      e.target.closest('[data-tix-modal]') ||
      e.target.closest('[data-micromodal-trigger]');

    if (trigger) {
      e.preventDefault();
      var id =
        trigger.getAttribute('data-tix-modal') ||
        trigger.getAttribute('data-micromodal-trigger');
      openModalById(id, trigger);
      return;
    }

    // Close triggers
    var closeBtn = e.target.closest('[data-tix-close],[data-micromodal-close]');
    if (closeBtn) {
      e.preventDefault();
      closeModal(closeBtn.closest('.tix-modal'));
      return;
    }

    // Close on overlay click
    var overlay = e.target.closest('.tix-modal__overlay');
    if (overlay) {
      e.preventDefault();
      closeModal(overlay.closest('.tix-modal'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.tix-modal.is-open');
    if (!open) return;
    closeModal(open);
  });
})();
